import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'reCaptchaSiteKey',
  initialState: null as string | null,
  reducers: {
    setReCaptchaSiteKey(state, action: PayloadAction<string>) {
      return action.payload || null;
    },
  },
});

export const { setReCaptchaSiteKey } = slice.actions;

export default slice.reducer;
